import Reports from "./Reports/Route";
// import Settings from "./Settings/Routes";

export default [...Reports];
